<section class="flex justify-content-center mt-4">
  <div class="card-table col-12 flex flex-column">
      <div class="pt-1">
          <CustomTitle [title]="'msg.gestionTramites' | translate" [showTag]="false"
                       [styleClass]="'font-principal font-23 app-title-page-color mt-4 text-uppercase font-medium'"/>
      </div>
      <p-tabView [(activeIndex)]="activeTabIndex">
          <p-tabPanel>
              <ng-template pTemplate="header">
                  <div class="flex gap-1 align-items-center">
                       <span>
                          {{'common.pendientes' |translate}}
                      </span>
                  </div>
              </ng-template>
              <app-gestionar-actividades-pendientes [tramEstados]="['ACTIVO']" [tramActividadEstados]="['PENDIENTE']"></app-gestionar-actividades-pendientes>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="flex gap-1 align-items-center">
                     <span>
                        {{'common.finalizados' |translate}}
                    </span>
                </div>
            </ng-template>
            <app-gestionar-actividades-pendientes [tramEstados]="['FINALIZADO','RECHAZADO']" [tramActividadEstados]="['FINALIZADO','REASIGNADO','REABIERTO']"></app-gestionar-actividades-pendientes>
        </p-tabPanel>
      </p-tabView>
  </div>
</section>
